import { render, staticRenderFns } from "./GwbIcon.vue?vue&type=template&id=04971204"
import script from "./GwbIcon.vue?vue&type=script&lang=js"
export * from "./GwbIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports